import React from "react";
import { BackgroundColor } from "types/componentBackground";
import DateOnlyFormat from "../../../components/DateOnlyFormat";
import LinkCard from "../../../components/Card/LinkCard";
import { PartialSanityImageType } from "@silversea-ssc/ui-components-react";

interface CruiseEventCard {
  cardBackgroundColor: BackgroundColor;
  image?: PartialSanityImageType;
  title: string;
  date: Date;
  location: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CruiseEventCard: React.FC<React.PropsWithChildren<CruiseEventCard>> = ({
  image,
  title,
  date,
  location,
  cardBackgroundColor,
  onClick
}) => {
  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      title={title}
      image={image}
      imageAltText={title}
      description={
        <>
          {date && (
            <DateOnlyFormat
              value={date}
              format={{
                year: "numeric",
                month: "long",
                day: "numeric"
              }}
            />
          )}
          <p>{location}</p>
        </>
      }
      action={{ onClick: onClick }}
    />
  );
};

export default CruiseEventCard;
